import { useRenewalSetupStore } from '../stores';

export const useIsAnyStepSubmitted = () => {
  const plansPlanYearSubmitted = useRenewalSetupStore((state) => state.plansPlanYear.isSubmitted);
  const copaysSubmitted = useRenewalSetupStore((state) => state.copays.isSubmitted);
  return plansPlanYearSubmitted || copaysSubmitted;
};
